// Copyright (c) 2022 by Move Closer

/**
 * Formats date to the DD.MM.YYYY format
 *
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const filterDate = (value: string): string => {
  const localDate = new Date(value.replaceAll('-', '/').replaceAll('.', '/'))

  const day = new Date(localDate).getDate() // safari
  const month = new Date(localDate).getMonth() + 1
  const year = new Date(localDate).getFullYear()

  return `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`
}
